<template>
    <div>
        <card-header title="WIAA Cert Lookup" icon="fa-search-plus"/>

        <card-body>
            <card-list>
                <search-list-item @action="searchCertification" placeholder="Search by name, email, or WIAA ID"/>
                <container-list-item padded class="pt-0">
                    Search by name, email address, or WIAA Membership ID
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    export default {
        components: {
            CardHeader, 
            CardBody, 
            CardList, 
            SearchListItem,
            ContainerListItem
        },
        props: ['card', 'child'],
        methods: {
            searchCertification: function (query) {
                if (!query || query.length < 3) {
                    this.$buefy.toast.open({
                        message: 'Please enter at least 3 characters to search',
                        type: 'is-warning',
                        duration: 3000
                    });
                    return;
                }
                
                this.$openCard('wiaa-certification-search', {query: query}, this.card);
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>